import * as React from "react";

const interMediateLine: React.FC = () => {
    return (
        <svg viewBox="0 0 35 27" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M0 6C0 2.68629 2.68629 0 6 0H29C32.3137 0 35 2.68629 35 6V21C35 24.3137 32.3137 27 29 27H6C2.68629 27 0 24.3137 0 21V6Z"
                fill="#B91918"
            />
            <path
                d="M14.9278 18.074C14.9278 18.074 14.8198 18.452 14.8198 19.046C14.8198 19.622 14.9278 20 14.9278 20H20.0758C20.0758 20 20.2018 19.622 20.2018 19.046C20.2018 18.452 20.0758 18.074 20.0758 18.074H19.0138V9.326H20.0758C20.0758 9.326 20.2018 8.948 20.2018 8.372C20.2018 7.778 20.0758 7.4 20.0758 7.4H14.9278C14.9278 7.4 14.8198 7.778 14.8198 8.372C14.8198 8.948 14.9278 9.326 14.9278 9.326H15.9898V18.074H14.9278Z"
                fill="white"
            />
        </svg>
    );
};

export default React.memo(interMediateLine);
